
import apiMe from '@/api/proxyWeb/me'
import apiUtilisateurs from '@/api/proxyWeb/utilisateurs'
import { getFromLocation } from '@/api/proxyWeb/api'

export default {

    add({ commit }, utilisateur) {

        return new Promise((resolve, reject) => {
        
            apiUtilisateurs.post(utilisateur)
                .then( response => {                    
                    
                    getFromLocation(response.headers.location)
                        .then( utilisateur => {
                            resolve(utilisateur)
                            commit('addUtilisateur', utilisateur)
                        })
                        .catch(error => reject(error))
                })
                .catch(error => reject(error))
            });
    },

    get({ commit }) {

        commit('setCurrentUtilisateur', null)

        return new Promise(resolve => {

            apiMe.get()
                .then(utilisateur => {
                    commit('setCurrentUtilisateur', utilisateur)
                    resolve(utilisateur)
                })
            })      
    },

    getAddresses({ commit }) {

        commit('setAddresses', [])

        return new Promise(resolve => {
        
            apiMe.getAddresses()
                .then(addresses => {
                    commit('setAddresses', addresses)
                    resolve(addresses)
                })
            }) 
    },

    getAll({ commit }) {

        commit('setUtilisateurs', null)

        return new Promise(resolve => {
        
            Promise.all([
                apiUtilisateurs.count(),
                apiUtilisateurs.list()
            ])
            .then( ([ count, utilisateurs ]) => {
                commit('setCount', count)
                commit('setUtilisateurs', utilisateurs)
                resolve(utilisateurs)
            })
        })
    },  

    getCollection({ commit }) {

        commit('setUtilisateurs', null)

        return new Promise(resolve => {
        
            Promise.all([
                apiUtilisateurs.getAll()
            ])
            .then( ([ utilisateurs ]) => {
                commit('setUtilisateurs', utilisateurs)
                resolve(utilisateurs)
            })
        })
    },      

    getHabilitations({ commit }) {

        commit('setHabilitations', [])        

        return new Promise(resolve => {
        
            apiMe.getHabilitations()
                .then(habilitations => {
                    commit('setHabilitations', habilitations)
                    resolve(habilitations)
                })
            })       
    },

    getNext({ commit, state }) {

        let params = {
            page: state.page + 1 
        }
        
        return apiUtilisateurs.list(params)
            .then(utilisateurs => {
                commit('setNextUtilisateurs', utilisateurs)
            })
    },

    update({ commit }, utilisateur) {

        return apiUtilisateurs.patch(utilisateur)
            .then( () => commit('updateUtilisateur', utilisateur) )
    }
}